import client from "@/utils/request";

export const login = (params = {}) => {
  return client.request({
    url: '/api/v2/admin/login',
    method: 'get',
    params: params
  })
}

export const auth = (params = {}) => {
  return client.request({
    url: '/api/v2/admin/auth',
    method: 'get',
    params: params
  })
}

export const sign = (params = {}) => {
  return client.request({
    url: '/api/v2/admin/exchange_customer_token_by_sign',
    method: 'get',
    params: params
  })
}

export const getShopInfo = (params = {}) => {
  return client.request({
    url: '/api/v2/admin/get_shop_info',
    method: 'get',
    params: params
  })
}

export const getPay = (param = {}) => {
  return client.post("/api/v2/admin/add_pricing_plan", param)
}

/**
 * 检查定价计划是否充值
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const checkPrice = (param = {}) => {
  return client.post("/api/v2/admin/check_pricing_plan", param)
}